module.exports = __webpack_public_path__ + "static/media/corona_logo_blue_red.90d2cc9b.png";